// @flow
import * as React from 'react';
import LoadingSection from './LoadingSection';
import { setDocumentTitle } from '../utils/meta';

type Props = {
  error: ?Error,
  pastDelay: boolean
};

export default class LoadableLoadingSection extends React.PureComponent<Props> {
  componentDidMount() {
    setDocumentTitle('Idealist', null);
  }

  render() {
    if (this.props.error) {
      throw this.props.error;
    }
    if (this.props.pastDelay) {
      return <LoadingSection delay={0} />;
    }
    return null;
  }
}
